<template>
  <div class="dashboard">
    <ui-loading-circle :descText="'downloadingDot'" :applyBackground="true" v-if="!isLoaded && !isError"/>
    <div class="dashboard-visual" v-if="isLoaded">
      <h1>Get started with usability testing easily</h1>
      <p>
        사용자 테스트를 더 빠르고 쉽게 수행할 수 있습니다. <br>
        뷰저블UT! 지금 바로 경험해보세요.
      </p>
      <span @click="addUt">
        UT 등록
      </span>
    </div>
    <div class="dashboard-cont" v-if="isLoaded">
      <h3>
        <span>{{utList.length}}</span> 개의 UT가 등록되어 있습니다.

        <span class="timezone">타임존: ({{ timezone || DEFAULT_TIMEZONE}}) {{userData.timezoneName || DEFAULT_TIMEZONE_NAME}}</span>
      </h3>
      <template v-if="utList.length > 0">
        <template v-for="(ut, index) in utList">
          <dashboard-pane
            :data="ut"
            :imageCheck="imageCheck(ut)"
            :contStyle="lastItemCheck(index)" v-bind:key="index"
            @onDeleteUt="onDeleteUt"
          />
        </template>
        <dashboard-pane :contStyle="lastItemCheck(utList.length, 'plus')"/>
      </template>

      <template v-else>
        <div class="card-none-cont">
          <img src="@/assets/images/visual-card-none.svg" alt="">
          <h3>등록된 UT가 없습니다.</h3>
          <p>‘UT 등록’을 클릭하여 신규 프로젝트를 <br>생성해 보세요!</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { getAllDashboard } from '@/api/dashboard'

import DashboardPane from '@/components/dashboard/DashboardPane'

import { DEFAULT_TIMEZONE, DEFAULT_TIMEZONE_NAME } from '@/libs/constants'
import { getOffset } from '@/libs/utils'

export default {
  name: 'Dashboard',
  components: {
    DashboardPane
  },
  props: [
    'error'
  ],
  data () {
    return {
      isLoaded: false,
      isError: false,
      isPopupOpen: false,
      utList: [],
      DEFAULT_TIMEZONE: DEFAULT_TIMEZONE,
      DEFAULT_TIMEZONE_NAME: DEFAULT_TIMEZONE_NAME
    }
  },
  created () {
    this.isError = this.error
    this.getData()
  },
  mounted () {
  },
  methods: {
    getData () {
      getAllDashboard().then(data => {
        this.utList = data
        this.isLoaded = true
      })
    },
    addUt () {
      this.$router.push({ name: 'add' })
    },
    onDeleteUt () {
      this.getData()
    }
  },
  computed: {
    ...mapState([
      'userData'
    ]),
    timezone () {
      return getOffset(this.userData.timezoneName)
    },
    lastItemCheck () {
      return (index, type) => {
        let extraClass = ''
        if (type === 'plus') {
          extraClass = 'cont-plus'
        }
        let resultClass = (index + 1) % 3 === 0 ? 'last-cont ' : ''
        return resultClass + extraClass
      }
    },
    imageCheck () {
      return (item) => {
        return item.capture === '' || !item.capture ? 'visual-none' : 'visual'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  width: 870px;
  margin: 90px auto 0;
  padding-bottom: 30px;
  .dashboard-visual {
    position: relative;
    width: 100%;
    height: 200px;
    background: url('../../../assets/images/visual-dashboard.svg') no-repeat left center;
    background-size: 220px 196px;
    box-sizing: border-box;
    padding-left: 245px;
    overflow: hidden;
    margin-bottom: 45px;
    h1 {
      max-width: 480px;
      font-size: 46px;
      font-weight: 500;
      color: #333;
      line-height: 1.09;
      letter-spacing: -0.2px;
      margin: 30px 0 15px;
    }
    p {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.57;
      color: #767676;
    }
    span {
      position: absolute;
      right: 0;
      bottom: 20px;
      width: 100px;
      height: 100px;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      box-shadow: 0 12px 11px -5px rgba(0, 0, 0, 0.06);
      background: #ec0047 url('../../../assets/images/icon-registUT.svg') no-repeat center bottom 25px;
      border-radius: 50%;
      line-height: 88px;
      cursor: pointer;
      transition: 0.3s;
      &:hover {
        background: #c12a44 url('../../../assets/images/icon-registUT.svg') no-repeat center bottom 25px;
      }
    }
  }
  .dashboard-cont {
    width: 100%;
    font-size: 0;
    margin-bottom: 50px;
    & > h3 {
      position: relative;
      padding-bottom: 10px;
      border-bottom: 1px solid #d8d8d8;
      font-size: 13px;
      font-weight: 500;
      color: #666;
      margin-bottom: 25px;
      span {
        font-size: 28px;
        color: #222;
        margin-right: 3px;
      }

      span.timezone {
        position: absolute;
        bottom: 13px;
        right: 0;
        font-size: 13px;
        font-weight: 500;
        color: #666;
      }
    }
    .card-none-cont {
      background: none;
      width: 100%;
      padding: 140px 0;
      text-align: center;
      display: block;
      h3 {
        font-size: 20px;
        font-weight: 500;
        line-height: 1.1;
        color: #444;
        margin: 25px 0 15px;
      }
      p {
        font-size: 14px;
        font-weight: 500;
        line-height: 1.57;
        color: #5a8496;
      }
    }
  }
}

@media all and (max-width: 990px) {
  .dashboard {
      width: calc(100% - 40px);
      min-width: 768px;
      .dashboard-visual {
          background: url('../../../assets/images/visual-dashboard.svg') no-repeat left center;
          background-size: 200px;
          padding-left: 220px;
      }
  }
}
</style>
